<template>
	<div class="qna-q-list" data-app>
		<PageHeader>
			<p>
				총 {{ counter.totalCount | number }} |
				<span class="color-green"
					>정상 {{ counter.normalCount | number }}</span
				>
				|
				<span class="font-red"
					>차단 {{ counter.blockCount | number }}</span
				>
				|
				<span class="color-orange"
					>검수 {{ counter.inspectionCount | number }}</span
				>
				|
				<span
					>정상AI 답변 {{ counter.qnaAiVisibleCount | number }}</span
				>
				|
				<span
					>비노출AI 답변 {{ counter.qnaAiHiddenCount | number }}</span
				>
			</p>
		</PageHeader>
		<form @submit.prevent="search(0)">
			<ManagingSection :columnCount="2">
				<ManagingBox title="등록일">
					<RadioList
						v-model="createdAtType"
						:radioList="createdAtTypeList"
						@input="createdAtTypeChange"
					/>
					<DateRange v-model="createdAt" type="date" />
				</ManagingBox>
				<ManagingBox title="검색">
					<SelectInput
						ref="SearchType"
						:defaultSelectValue="searchType"
						:selectList="searchTypeList"
						@change="searchTypeChange"
					/>
				</ManagingBox>
				<ManagingBox title="카테고리">
					<CategorySelector
						ref="CategorySelector"
						:category_level="2"
						@change="categoryChange"
					/>
				</ManagingBox>
				<ManagingBox title="상태">
					<RadioList v-model="state" :radioList="stateList" />
				</ManagingBox>
				<ManagingBox title="AI답변 타입">
					<RadioList v-model="qnaAiType" :radioList="qnaAiTypeList" />
				</ManagingBox>
				<ManagingBox title="질문고정">
					<RadioList v-model="isFixed" :radioList="isFixedList" />
				</ManagingBox>
				<ManagingBox title="AI답변 내용">
					<input
						v-model="qnaAiContent"
						type="text"
						:disabled="qnaAiType === null"
					/>
				</ManagingBox>
				<ManagingBox title="AI답변 노출여부">
					<RadioList
						v-model="qnaAiIsDisplay"
						:radioList="qnaAiIsDisplayList"
						:disabled="qnaAiType === null ? 'all' : false"
					/>
				</ManagingBox>
			</ManagingSection>
			<div class="btn-wrap-main cast-detail__button-wrapper">
				<button type="submit" class="btn-main blue" v-text="'검색'" />
				<button
					type="button"
					class="btn-main blue bordered"
					v-text="'초기화'"
					@click="initSearch"
				/>
			</div>
		</form>
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<div class="section__info__left">
					검색 결과 {{ totalCount | number }}건
				</div>
				<div class="section__info__right">
					<button
						:disabled="!checkList.length"
						type="button"
						class="btn orange section__info__items"
						v-text="'일괄차단'"
						@click="activeModal"
					/>
					<button
						class="btn-excel section__info__items"
						type="button"
						@click="openExcelModal"
						v-text="'CSV'"
					/>
					<Selector
						v-model="order"
						:optionList="orderList"
						nameKey="text"
						class="section__info__items"
						@input="search(0)"
					/>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th class="qna-q-list__checkout-column">
							<input
								v-model="allCheckModel"
								:value="allCheck"
								type="checkbox"
							/>
						</th>
						<th class="qna-q-list__id-column">질문번호</th>
						<th class="qna-q-list__date-column">등록일시</th>
						<th class="qna-q-list__fix-column">질문고정</th>
						<th class="qna-q-list__ai-type">AI답변타입</th>
						<th class="qna-q-list__cate-column">카테고리</th>
						<th class="qna-q-list__nickname-column">작성자</th>
						<th class="qna-q-list__title-column">제목/내용</th>
						<th class="qna-q-list__ai-dp">AI답변노출여부</th>
						<th class="qna-q-list__a-column">답변</th>
						<th class="qna-q-list__like-column">좋아요</th>
						<th class="qna-q-list__view-column">조회수</th>
						<th class="qna-q-list__state-column">상태</th>
					</tr>
				</thead>
				<tbody v-if="list.length">
					<tr v-for="item in list" :key="item.id">
						<td>
							<input
								v-model="checkListModel"
								:value="item.id"
								type="checkbox"
								:disabled="
									item.state === '차단' || item.isOfficial
								"
							/>
						</td>
						<td>
							<RouterLink
								:to="`/qna/q/${item.id}`"
								class="link"
								v-text="item.id"
							/>
						</td>
						<td>{{ item.createdAt }}</td>
						<td>{{ item.isFixed ? 'Y' : 'N' }}</td>
						<td>{{ item.aiType }}</td>
						<td>{{ item.secondCategoryText }}</td>
						<td>
							<p v-if="item.isOfficial">관리자</p>
							<RouterLink
								v-else
								:to="`/register/register-info/${item.register.idRegister}`"
								target="_blank"
								class="link"
								v-text="item.register.nickName"
							/>
						</td>
						<td class="text-left">
							<RouterLink :to="`/qna/q/${item.id}`">
								<b v-if="item.title">{{ item.title }}</b>
								<pre>{{ item.text }}</pre>
							</RouterLink>
							<div class="d-flex mt-2">
								<div
									v-for="(img, i) in item.doc.qna_image"
									:key="`img-${item.id}-${i}`"
									class="mr-1"
								>
									<Thumbnail
										:src="`${env.IMAGE_STORAGE_PATH}/${img.key}`"
										:height="100"
										imgMaxHeight="300px"
									/>
									<div
										v-if="img.state === '부적합'"
										class="w100 text-center red white--text"
										v-text="img.state"
									/>
								</div>
							</div>
						</td>
						<td>{{ item.aiIsDp }}</td>
						<td
							:class="{ link: item.replyCount > 0 }"
							v-text="item.replyCount"
							@click="checkAnswerNumber(item.replyCount, item.id)"
						/>
						<td>{{ item.likeCount }}</td>
						<td>{{ item.hit | number }}</td>
						<td :class="item.state | stateClass">
							{{ item.state }}
						</td>
					</tr>
				</tbody>
				<tbody v-else>
					<tr>
						<td colspan="11">조회된 데이터가 없습니다.</td>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				slot="pagination"
				:totalItem="totalCount"
				:limit="limit"
				:offset="offset"
				@to="search($event.offset)"
			/>
		</ManagingSection>
	</div>
</template>
<script>
	import moment from 'moment';
	import util from '@/util';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '@/components/RadioList.vue';
	import DateRange from '@/components/DateRange.vue';
	import SelectInput from '@/components/SelectInput.vue';
	import CategorySelector from '@/components/common/CategorySelector.vue';
	import Selector from '@/components/Selector.vue';
	import Thumbnail from '@/components/Thumbnail.vue';
	import PaginationBox from '@/components/PaginationBox.vue';

	export default {
		name: 'QnaQList',
		components: {
			PageHeader,
			ManagingSection,
			ManagingBox,
			RadioList,
			DateRange,
			SelectInput,
			CategorySelector,
			Selector,
			Thumbnail,
			PaginationBox,
		},
		data() {
			const createdAtTypeList = [
				{ id: '3', value: '3개월' },
				{ id: '6', value: '6개월' },
				{ id: '12', value: ' 1년' },
				{ id: 'custom', value: '전체' },
			];

			const searchTypeList = [
				{ value: 'text', name: '제목/내용' },
				{ value: 'nickName', name: '작성자' },
				{ value: 'registerId', name: '회원번호' },
				{ value: 'id', name: '질문번호' },
			];

			const stateList = [
				{ id: null, value: '전체' },
				{ id: '정상', value: '정상' },
				{ id: '차단', value: '차단' },
				{ id: '검수', value: '검수' },
			];

			const qnaAiTypeList = [
				{ id: null, value: '설정안함' },
				{ id: 'all', value: '전체' },
				{ id: 'question', value: '질문' },
				{ id: 'review', value: '리뷰' },
				{ id: 'product', value: '제품' },
			];

			const isFixedList = [
				{ id: null, value: '전체' },
				{ id: 'Y', value: 'Y' },
				{ id: 'N', value: 'N' },
			];

			const qnaAiIsDisplayList = [
				{ id: null, value: '전체' },
				{ id: '1', value: '노출' },
				{ id: '0', value: '미노출' },
			];

			const orderList = [
				{ value: 'id_desc', text: '최근 등록순' },
				{ value: 'id_asc', text: '과거 등록순' },
				{ value: 'reply_count_desc', text: '답변 많은순' },
				{ value: 'reply_count_asc', text: '답변 적은순' },
				{ value: 'like_count_desc', text: '좋아요 많은순' },
				{ value: 'like_count_asc', text: '좋아요 적은순' },
				{ value: 'hit_count_desc', text: '조회수 높은순' },
				{ value: 'hit_count_asc', text: '조회수 낮은순' },
			];

			return {
				counter: {},
				createdAtTypeList,
				createdAtType: createdAtTypeList[0].id,
				createdAt: {
					from: moment().add(-3, 'M').format('YYYY-MM-DD'),
					to: moment().format('YYYY-MM-DD'),
				},
				searchTypeList,
				searchType: searchTypeList[0].value,
				searchValue: '',
				idFirstCategory: '',
				idSecondCategory: '',
				stateList,
				state: stateList[0].id,
				qnaAiTypeList,
				qnaAiType: qnaAiTypeList[0].id,
				isFixedList,
				isFixed: isFixedList[0].id,
				qnaAiContent: '',
				qnaAiIsDisplayList,
				qnaAiIsDisplay: qnaAiIsDisplayList[0].id,
				orderList,
				order: orderList[0].value,
				limit: 50,
				offset: 0,
				totalCount: 0,
				list: [],
				allCheck: false,
				checkList: [],
				lastParams: {},
			};
		},
		computed: {
			allCheckModel: {
				get() {
					return this.allCheck;
				},
				set(allCheck) {
					this.checkList = allCheck
						? this.list
								.filter(
									item =>
										item.state !== '차단' &&
										!item.isOfficial
								)
								.map(item => item.id)
						: [];
					this.allCheck = allCheck;
				},
			},
			checkListModel: {
				get() {
					return this.checkList;
				},
				set(checkList) {
					this.allCheck =
						this.list.filter(
							item => item.state !== '차단' && !item.isOfficial
						).length === checkList.length;
					this.checkList = checkList;
				},
			},
		},
		mounted() {
			this.init();
		},
		methods: {
			setFilter() {
				const query = this.$route.query;

				if (query.createdAtType) {
					this.createdAtType = query.createdAtType;

					if (query.createdAtType === 'custom') {
						this.createdAt = {
							from: query.from,
							to: query.to,
						};
					} else {
						this.createdAt = {
							from: moment()
								.add(-parseInt(query.createdAtType), 'M')
								.format('YYYY-MM-DD'),
							to: moment().format('YYYY-MM-DD'),
						};
					}
				}

				if (query.searchType) {
					this.searchType = query.searchType;
					this.$refs.SearchType.selectModel = query.searchType;
				}

				if (query.searchValue) {
					this.searchValue = query.searchValue;
					this.$refs.SearchType.inputModel = query.searchValue;
				}

				if (query.idFirstCategory) {
					this.idFirstCategory = Number(query.idFirstCategory);
				}

				if (query.idSecondCategory) {
					this.idSecondCategory = Number(query.idSecondCategory);
				}

				if (query.state) {
					this.state = query.state;
				}

				if (query.qnaAiType) {
					this.qnaAiType = query.qnaAiType;
				}

				if (query.isFixed) {
					this.isFixed = query.isFixed;
				}

				if (query.qnaAiContent) {
					this.qnaAiContent = query.qnaAiContent;
				}

				if (query.qnaAiIsDisplay) {
					this.qnaAiIsDisplay = query.qnaAiIsDisplay;
				}

				if (query.order) {
					this.order = query.order;
				}

				if (query.offset) {
					this.offset = Number(query.offset);
				}
			},
			setQuery() {
				const query = {};

				if (this.createdAtType !== this.createdAtTypeList[0].id) {
					query.createdAtType = this.createdAtType;
				}

				if (this.createdAtType === 'custom') {
					query.from = this.createdAt.from;
					query.to = this.createdAt.to;
				}

				if (this.searchType !== this.searchTypeList[0].value) {
					query.searchType = this.searchType;
				}

				if (this.searchValue) {
					query.searchValue = this.searchValue;
				}

				if (this.idFirstCategory) {
					query.idFirstCategory = String(this.idFirstCategory);
				}

				if (this.idSecondCategory) {
					query.idSecondCategory = String(this.idSecondCategory);
				}

				if (this.state !== this.stateList[0].id) {
					query.state = this.state;
				}

				if (this.qnaAiType !== this.qnaAiTypeList[0].id) {
					query.qnaAiType = this.qnaAiType;
				}

				if (this.isFixed !== this.isFixedList[0].id) {
					query.isFixed = this.isFixed;
				}

				if (this.qnaAiContent) {
					query.qnaAiContent = this.qnaAiContent;
				}

				if (this.qnaAiIsDisplay !== this.qnaAiIsDisplayList[0].id) {
					query.qnaAiIsDisplay = this.qnaAiIsDisplay;
				}

				if (this.order !== this.orderList[0].value) {
					query.order = this.order;
				}

				if (this.offset) {
					query.offset = String(this.offset);
				}

				this.$router.replace({ query }).catch(() => {});
			},
			async loadCounter() {
				const { data } = await this.$axiosAdmin2.get(
					'/api/qna/state/count'
				);
				this.counter = data;
			},
			getParams() {
				const params = {
					order: this.order,
					limit: this.limit,
					offset: this.offset,
				};

				if (this.createdAt.from) {
					params.startCreatedAt = moment(
						this.createdAt.from
					).valueOf();
				}

				if (this.createdAt.to) {
					const endAt = moment(this.createdAt.to)
						.add(1, 'd')
						.add(-1, 's')
						.toISOString();
					params.endCreatedAt = moment(endAt).valueOf();
				}

				if (this.searchValue) {
					params[this.searchType] = this.searchValue;
				}

				if (this.idFirstCategory) {
					params.idFirstCategory = this.idFirstCategory;
				}

				if (this.idSecondCategory) {
					params.idSecondCategory = this.idSecondCategory;
				}

				if (this.state) {
					params.state = this.state;
				}

				if (this.isFixed) {
					params.isFixed = this.isFixed === 'Y' ? true : false;
				}

				if (this.qnaAiType) {
					params.qnaAiType = this.qnaAiType;

					if (this.qnaAiContent) {
						params.qnaAiContent = this.qnaAiContent;
					}

					if (this.qnaAiIsDisplay) {
						params.qnaAiIsDisplay = this.qnaAiIsDisplay;
					}
				}

				return params;
			},
			getAiType(log) {
				return log
					? this.qnaAiTypeList.find(item => item.id === log.type)
							.value
					: '';
			},
			getAiIsDp(log) {
				return log ? (log.isDisplay ? '노출' : '미노출') : '';
			},
			async setList() {
				this.loadCounter();

				const params = this.getParams();
				const { data } = await this.$axiosAdmin2.get('/api/qna', {
					params,
				});

				this.totalCount = data.totalCount;
				this.list = data.qnaList.map(item => ({
					...item,
					doc: item.doc && JSON.parse(item.doc),
					createdAt: moment(item.createdAt).format(
						'YYYY-MM-DD HH:mm'
					),
					aiType: this.getAiType(item.qnaAiLog),
					aiIsDp: this.getAiIsDp(item.qnaAiLog),
				}));
				this.lastParams = params;
			},
			init() {
				this.setFilter();
				this.setList();
			},
			search(offset) {
				this.offset = offset;

				this.setQuery();
				this.setList();
			},
			initSearch() {
				this.createdAtType = this.createdAtTypeList[0].id;
				this.createdAt = {
					from: moment().add(-3, 'M').format('YYYY-MM-DD'),
					to: moment().format('YYYY-MM-DD'),
				};
				this.$refs.SearchType.init();
				(this.searchType = this.searchTypeList[0].value),
					(this.searchValue = '');
				this.$refs.CategorySelector.init();
				this.idFirstCategory = '';
				this.idSecondCategory = '';
				this.state = this.stateList[0].id;
				this.qnaAiType = this.qnaAiTypeList[0].id;
				this.isFixed = this.isFixedList[0].id;
				this.qnaAiContent = '';
				this.qnaAiIsDisplay = this.qnaAiIsDisplayList[0].id;
				this.order = this.orderList[0].value;

				this.search(0);
			},
			createdAtTypeChange(createdAtType) {
				if (createdAtType === 'custom') {
					this.createdAt = {
						from: '',
						to: '',
					};
				} else {
					this.createdAt = {
						from: moment()
							.add(-parseInt(createdAtType), 'M')
							.format('YYYY-MM-DD'),
						to: moment().format('YYYY-MM-DD'),
					};
				}
			},
			searchTypeChange({ select, input }) {
				this.searchType = select;
				this.searchValue = input;
			},
			categoryChange({ category1, category2 }) {
				this.idFirstCategory = category1;
				this.idSecondCategory = category2;
			},
			async excelModalCb(offset) {
				try {
					const params = this.lastParams;

					params.offset = offset;
					params.limit = 10000;
					params.isCsvDownload = true;

					const { data } = await this.$axiosAdmin2.get('/api/qna', {
						params,
					});

					const headers = [
						'질문번호',
						'등록일시',
						'카테고리',
						'작성자',
						'제목/내용',
						'AI 답변 노출여부',
						'AI 답변 좋아요',
						'AI 답변 아쉬워요',
						'답변',
						'좋아요',
						'조회수',
						'상태',
					];
					const list = data.qnaList.map(item => [
						item.id,
						moment(item.createdAt).format('YYYY-MM-DD HH:mm'),
						item.secondCategoryText,
						item.register.nickName ?? '관리자',
						`${item.title}\n${item.text}`,
						item.qnaAiLog?.isDisplay ? '노출' : '미노출',
						item.qnaAiLog?.isDisplay
							? item.qnaAiLikeCount || 0
							: '',
						item.qnaAiLog?.isDisplay
							? item.qnaAiDisLikeCount || 0
							: '',
						item.replyCount,
						item.likeCount,
						item.hit,
						item.state,
					]);

					util.getCsv(
						[list],
						[document.title],
						[headers],
						`${document.title}_${new Date().getTime()}`
					);
				} catch (e) {
					console.error(e);
					alert('CSV를 생성하는데 실패했습니다.');
				}
			},
			openExcelModal() {
				this.$store.commit('modal/toggleModal', {
					id: 'ExcelDownList',
					params: {
						total: this.totalCount,
						type: 'qnaQList',
						clickCb: this.excelModalCb,
					},
				});
			},
			checkAnswerNumber(answerNumber, answerId) {
				if (answerNumber <= 0) return;

				const routeData = this.$router.resolve({
					path: '/qna/a/list',
					query: { answerName: 'qnaId', qnaId: answerId },
				});

				window.open(routeData.href, '_blank');
			},
			modalComplete() {
				this.$store.commit('modal/toggleModal', false);
				this.allCheckModel = false;
				this.checkListModel = [];
				this.search(0);
			},
			activeModal() {
				this.$store.commit('modal/toggleModal', {
					id: 'QnaStateBatchBlock',
					params: {
						ids: this.checkList,
						type: '질문',
						modalComplete: this.modalComplete,
					},
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.qna-q-list {
		&__checkout-column {
			width: 40px;
		}

		&__id-column {
			width: 70px;
		}

		&__date-column {
			width: 140px;
		}

		&__fix-column {
			width: 70px;
		}

		&__ai-type {
			width: 80px;
		}

		&__cate-column {
			width: 140px;
		}

		&__nickname-column {
			width: 140px;
		}

		&__ai-dp {
			width: 100px;
		}

		&__a-column {
			width: 70px;
		}

		&__like-column {
			width: 70px;
		}

		&__view-column {
			width: 70px;
		}

		&__state-column {
			width: 70px;
		}
	}
</style>
